import { all } from 'axios';
import {
  FETCH_DUPLICATE_TRANSACTIONS_INIT,
  FETCH_DUPLICATE_TRANSACTIONS_SUCCESS,
  FETCH_DUPLICATE_TRANSACTIONS_ERROR,
  FETCH_MERCHANT_TRANSACTIONS_INIT,
  FETCH_MERCHANT_TRANSACTIONS_SUCCESS,
  FETCH_MERCHANT_RECENT_TRANSACTIONS_SUCCESS,
  FETCH_MERCHANT_TRANSACTIONS_ERROR,
  FETCH_TRANSACTIONS_INIT,
  FETCH_TRANSACTIONS_SUCCESS,
  FETCH_TRANSACTIONS_ERROR,
  FETCH_SETTLEMENTS_INIT,
  FETCH_SETTLEMENTS_SUCCESS,
  FETCH_SETTLEMENTS_ERROR,
  APPROVE_SETTLEMENTS_INIT,
  APPROVE_SETTLEMENTS_SUCCESS,
  APPROVE_SETTLEMENTS_ERROR,
  DOWNLOAD_SETTLEMENTS_ERROR,
  DOWNLOAD_SETTLEMENTS_INIT,
  DOWNLOAD_SETTLEMENTS_SUCCESS,
  DOWNLOAD_TRANSACTIONS_ERROR,
  DOWNLOAD_TRANSACTIONS_INIT,
  DOWNLOAD_TRANSACTIONS_SUCCESS,
  FETCH_TRANSACTION_SUMMARY_INIT,
  FETCH_TRANSACTION_SUMMARY_VOLUME_SUCCESS,
  FETCH_TRANSACTION_SUMMARY_VOLUME_FAILED,
  FETCH_TRANSACTION_SUMMARY_VOLUME_ALL,
  FETCH_TRANSACTION_SUMMARY_VOLUME_TODAY,
  FETCH_TRANSACTION_SUMMARY_VOLUME_YESTERDAY,
  FETCH_TRANSACTION_SUMMARY_VOLUME_THIS_MONTH,
  FETCH_TRANSACTION_SUMMARY_VOLUME_LAST_MONTH,
  FETCH_TRANSACTION_SUMMARY_ERROR,
  CHANGE_PAGE_LIMIT,
  CHANGE_PAGE,
  CHECK_TRANSACTION_STATUS_INIT,
  CHECK_TRANSACTION_STATUS_SUCCESS,
  CHECK_TRANSACTION_STATUS_ERROR,
  TRIGGER_WEBHOOK_INIT,
  TRIGGER_WEBHOOK_SUCCESS,
  TRIGGER_WEBHOOK_ERROR,
  FETCH_TRANSACTION_PROCESSED_INIT,
  FETCH_TRANSACTION_PROCESSED,
  FETCH_TRANSACTION_PROCESSED_ERROR,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  allTransactions: {
    data: [],
    loading: false,
    downloadLoading: false,
    error: null,
    currentPage: 1,
    pageSize: 50,
    totalRecords: 0,
    checkingStatus: false,
    triggerWebhook: false,
  },
  settlements: {
    data: [],
    loading: false,
    downloadLoading: false,
    error: null,
    creatingSettlement: false,
    pageSize: 50,
    currentPage: 1,
    totalRecords: 0,
  },
  duplicateTransactions: {
    data: [],
    loading: false,
    error: null,
    pageSize: 50,
    currentPage: 1,
    totalRecords: 0,
  },
  transactionSummarySuccess: {
    data: {
      total_transaction_amount: 0,
      total_wallet_amount: 0,
      total_count: 0,
    },
    loading: false,
    error: null,
  },
  transactionSummaryFailed: {
    data: {
      total_transaction_amount: 0,
      total_wallet_amount: 0,
      total_count: 0,
    },
    loading: false,
    error: null,
  },
  transactionSummaryAll: {
    data: {
      total_transaction_amount: 0,
      total_wallet_amount: 0,
      total_count: 0,
    },
    loading: false,
    error: null,
  },
  transactionSummaryToday: {
    data: {
      total_transaction_amount: 0,
      total_wallet_amount: 0,
      total_count: 0,
    },
    loading: false,
    error: null,
  },
  transactionSummaryYesterday: {
    data: {
      total_transaction_amount: 0,
      total_wallet_amount: 0,
      total_count: 0,
    },
    loading: false,
    error: null,
  },
  transactionSummaryThisMonth: {
    data: {
      total_transaction_amount: 0,
      total_wallet_amount: 0,
      total_count: 0,
    },
    loading: false,
    error: null,
  },
  transactionSummaryLastMonth: {
    data: {
      total_transaction_amount: 0,
      total_wallet_amount: 0,
      total_count: 0,
    },
    loading: false,
    error: null,
  },

  transactionProcessed: {
    data: [],
    loading: false,
    error: null,
  },
};

const transactions = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_PAGE_LIMIT: {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          pageSize: action.payload.pageSize,
        },
      };
    }

    case CHANGE_PAGE: {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          currentPage: action.payload.currentPage,
        },
      };
    }

    case FETCH_MERCHANT_TRANSACTIONS_INIT: {
      return {
        ...state,
        allTransactions: {
          ...state.allTransactions,
          loading: true,
        },
      };
    }

    case FETCH_MERCHANT_TRANSACTIONS_SUCCESS: {
      const { data, currentPage, totalRecords } = action.payload;
      return {
        ...state,
        allTransactions: {
          ...state.allTransactions,
          loading: false,
          data,
          currentPage,
          totalRecords,
        },
      };
    }

    case FETCH_MERCHANT_RECENT_TRANSACTIONS_SUCCESS: {
      const { data, currentPage, totalRecords } = action.payload;
      return {
        ...state,
        allTransactions: {
          ...state.allTransactions,
          loading: false,
          data,
          currentPage,
          totalRecords,
        },
      };
    }

    case FETCH_MERCHANT_TRANSACTIONS_ERROR: {
      return {
        ...state,
        allTransactions: {
          ...state.allTransactions,
          loading: false,
        },
      };
    }

    case FETCH_SETTLEMENTS_INIT: {
      return {
        ...state,
        settlements: {
          ...state.settlements,
          loading: true,
        },
      };
    }

    case FETCH_SETTLEMENTS_SUCCESS: {
      const { data, currentPage, totalRecords } = action.payload;
      return {
        ...state,
        settlements: {
          ...state.settlements,
          loading: false,
          data,
          currentPage,
          totalRecords,
          error: null,
        },
      };
    }

    case FETCH_SETTLEMENTS_ERROR: {
      return {
        ...state,
        settlements: {
          ...state.settlements,
          loading: false,
          error: action.payload,
        },
      };
    }

    case APPROVE_SETTLEMENTS_INIT: {
      return {
        ...state,
        settlements: {
          ...state.settlements,
          loading: true,
        },
      };
    }

    case APPROVE_SETTLEMENTS_SUCCESS: {
      const updatedData = state.settlements.data.map(
        (settlement) => (
          settlement._id !== action.payload._id ? settlement : action.payload
        ),
      );

      return {
        ...state,
        settlements: {
          ...state.settlements,
          data: updatedData,
          loading: false,
        },
      };
    }

    case APPROVE_SETTLEMENTS_ERROR: {
      return {
        ...state,
        settlements: {
          ...state.settlements,
          loading: false,
        },
      };
    }

    case DOWNLOAD_SETTLEMENTS_INIT: {
      return {
        ...state,
        settlements: {
          ...state.settlements,
          downloadLoading: true,
        },
      };
    }

    case DOWNLOAD_SETTLEMENTS_SUCCESS:
    case DOWNLOAD_SETTLEMENTS_ERROR: {
      return {
        ...state,
        settlements: {
          ...state.settlements,
          downloadLoading: false,
        },
      };
    }

    case FETCH_TRANSACTIONS_INIT: {
      return {
        ...state,
        allTransactions: {
          ...state.allTransactions,
          loading: true,
        },
      };
    }

    case FETCH_TRANSACTIONS_SUCCESS: {
      const { data, currentPage, totalRecords } = action.payload;
      return {
        ...state,
        allTransactions: {
          ...state.allTransactions,
          loading: false,
          data,
          currentPage,
          totalRecords,
        },
      };
    }

    case FETCH_TRANSACTIONS_ERROR: {
      return {
        ...state,
        allTransactions: {
          ...state.allTransactions,
          loading: false,
        },
      };
    }

    case DOWNLOAD_TRANSACTIONS_INIT: {
      return {
        ...state,
        allTransactions: {
          ...state.allTransactions,
          downloadLoading: true,
        },
      };
    }
    case DOWNLOAD_TRANSACTIONS_ERROR:
    case DOWNLOAD_TRANSACTIONS_SUCCESS: {
      return {
        ...state,
        allTransactions: {
          ...state.allTransactions,
          downloadLoading: false,
        },
      };
    }

    case CHECK_TRANSACTION_STATUS_INIT: {
      return {
        ...state,
        allTransactions: {
          ...state.allTransactions,
          checkingStatus: true,
        },
      };
    }

    case CHECK_TRANSACTION_STATUS_SUCCESS:
    case CHECK_TRANSACTION_STATUS_ERROR: {
      return {
        ...state,
        allTransactions: {
          ...state.allTransactions,
          checkingStatus: false,
        },
      };
    }

    case FETCH_DUPLICATE_TRANSACTIONS_INIT: {
      return {
        ...state,
        duplicateTransactions: {
          ...state.duplicateTransactions,
          loading: true,
        },
      };
    }

    case FETCH_DUPLICATE_TRANSACTIONS_SUCCESS: {
      return {
        ...state,
        duplicateTransactions: {
          ...state.duplicateTransactions,
          loading: false,
          data: action.payload,
        },
      };
    }

    case FETCH_DUPLICATE_TRANSACTIONS_ERROR: {
      return {
        ...state,
        duplicateTransactions: {
          ...state.duplicateTransactions,
          loading: false,
          error: false,
        },
      };
    }

    case FETCH_TRANSACTION_SUMMARY_INIT: {
      return {
        ...state,
        transactionSummary: {
          ...state.transactionSummary,
          loading: true,
        },
      };
    }

    case FETCH_TRANSACTION_SUMMARY_VOLUME_SUCCESS: {
      const { data } = action.payload;
      const { transactionType: tt, transactionStatus: ts } = action;
      const byTypeAndStatus = {};
      if (tt && ts) byTypeAndStatus[`${tt}${ts}`] = data;

      return {
        ...state,
        transactionSummarySuccess: {
          ...state.transactionSummarySuccess,
          loading: false,
          data,
          ...byTypeAndStatus,
        }
      };
    }
    case FETCH_TRANSACTION_SUMMARY_VOLUME_FAILED: {
      const { data } = action.payload;
      const { transactionType: tt, transactionStatus: ts } = action;
      const byTypeAndStatus = {};
      if (tt && ts) byTypeAndStatus[`${tt}${ts}`] = data;

      return {
        ...state,
        transactionSummaryFailed: {
          ...state.transactionSummaryFailed,
          loading: false,
          data,
          ...byTypeAndStatus,
        }
      };
    }
    case FETCH_TRANSACTION_SUMMARY_VOLUME_ALL: {
      const { data } = action.payload;
      const { transactionType: tt, transactionStatus: ts } = action;
      const byTypeAndStatus = {};
      if (tt && ts) byTypeAndStatus[`${tt}${ts}`] = data;

      return {
        ...state,
        transactionSummaryAll: {
          ...state.transactionSummaryAll,
          loading: false,
          data,
          ...byTypeAndStatus,
        }
      };
    }

    case FETCH_TRANSACTION_SUMMARY_VOLUME_TODAY: {
      const { data } = action.payload;
      const { transactionType: tt, transactionStatus: ts } = action;
      const byTypeAndStatus = {};
      if (tt && ts) byTypeAndStatus[`${tt}${ts}`] = data;

      return {
        ...state,
        transactionSummaryToday: {
          ...state.transactionSummaryToday,
          loading: false,
          data,
          ...byTypeAndStatus,
        }
      };
    }

    case FETCH_TRANSACTION_SUMMARY_VOLUME_YESTERDAY: {
      const { data } = action.payload;
      const { transactionType: tt, transactionStatus: ts } = action;
      const byTypeAndStatus = {};
      if (tt && ts) byTypeAndStatus[`${tt}${ts}`] = data;

      return {
        ...state,
        transactionSummaryYesterday: {
          ...state.transactionSummaryYesterday,
          loading: false,
          data,
          ...byTypeAndStatus,
        }
      };
    }

    case FETCH_TRANSACTION_SUMMARY_VOLUME_THIS_MONTH: {
      const { data } = action.payload;
      const { transactionType: tt, transactionStatus: ts } = action;
      const byTypeAndStatus = {};
      if (tt && ts) byTypeAndStatus[`${tt}${ts}`] = data;

      return {
        ...state,
        transactionSummaryThisMonth: {
          ...state.transactionSummaryThisMonth,
          loading: false,
          data,
          ...byTypeAndStatus,
        }
      };
    }
    case FETCH_TRANSACTION_SUMMARY_VOLUME_LAST_MONTH: {
      const { data } = action.payload;
      const { transactionType: tt, transactionStatus: ts } = action;
      const byTypeAndStatus = {};
      if (tt && ts) byTypeAndStatus[`${tt}${ts}`] = data;

      return {
        ...state,
        transactionSummaryLastMonth: {
          ...state.transactionSummaryLastMonth,
          loading: false,
          data,
          ...byTypeAndStatus,
        }
      };
    }

    case FETCH_TRANSACTION_SUMMARY_ERROR: {
      return {
        ...state,
        transactionSummary: {
          ...state.transactionSummary,
          loading: false,
          error: action.payload,
        },
      };
    }

    case FETCH_TRANSACTION_PROCESSED_INIT: {
      return {
        ...state,
        transactionProcessed: {
          ...state.transactionProcessed,
          loading: true,
        },
      };
    }

    case FETCH_TRANSACTION_PROCESSED: {
      const { data } = action.payload;

      return {
        ...state,
        transactionProcessed: {
          ...state.transactionProcessed,
          loading: false,
          data: data || []
        }
      };
    }

    case FETCH_TRANSACTION_PROCESSED_ERROR: {
      return {
        ...state,
        transactionProcessed: {
          ...state.transactionProcessed,
          loading: false,
          error: action.payload,
        },
      };
    }

    case TRIGGER_WEBHOOK_INIT: {
      return {
        ...state,
        allTransactions: {
          ...state.allTransactions,
          triggerWebhook: true,
        },
      };
    }

    case TRIGGER_WEBHOOK_SUCCESS:
    case TRIGGER_WEBHOOK_ERROR: {
      return {
        ...state,
        allTransactions: {
          ...state.allTransactions,
          triggerWebhook: false,
        },
      };
    }

    default:
      return state;
  }
};

export default transactions;
